import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

/* SizeTracker Styles */

export const SizeTrackerContainer = styled.div`
    position: absolute;
    left: 0;
    width: 100%;
`;

export const SizeTrackerText = styled.p`
    font-size: 13px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    margin-left: ${({ isOverflow }) => (isOverflow ? '28px' : 0)};
    color: ${({ showRedText, theme }) => (showRedText ? theme.colors.danger300 : 'inherit')};
`;

export const SizeTrackerRightContainer = styled.div`
    display: flex;
    margin-left: ${({ isOverflow }) => (isOverflow ? 'none' : 'auto')};
    margin-right: 32px;
`;

export const ProgressContainer = styled.div`
    width: 58px;
    height: 7px;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 8px;
    padding-bottom: 2px;
`;

export const TooltipContainer = styled(ReactTooltip)`
    width: 110px;
    padding: 16px 20px;
`;

export const TooltipText = styled.span`
    font-weight: 600;
`;
